import { render, staticRenderFns } from "./SettingsPayment.vue?vue&type=template&id=6d3c818b&"
import script from "./SettingsPayment.vue?vue&type=script&lang=js&"
export * from "./SettingsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports